import { render } from "./Test.vue?vue&type=template&id=090b095e&scoped=true&ts=true"
import script from "./Test.vue?vue&type=script&lang=ts"
export * from "./Test.vue?vue&type=script&lang=ts"

import "./Test.vue?vue&type=style&index=0&id=090b095e&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090b095e"]])

export default __exports__